import React from 'react';

const SignOutButton = ({signOut}) => {

    const handleSignOut = () => {
      localStorage.removeItem('year'); 
      localStorage.removeItem('schema');
      localStorage.removeItem('period'); 
      localStorage.removeItem('fak'); 
      localStorage.removeItem('kaf'); 
      localStorage.removeItem('grop');
      signOut();
    }

    return (
        <div className="header-user__sign-Out" onClick={handleSignOut}>выйти</div>
    )
};

export default SignOutButton;
